import { memo } from 'react';
import { Pressable, PressableProps, StyleSheet } from 'react-native';

function PressableOverlay(props: PressableProps) {
  return <Pressable style={StyleSheet.absoluteFill} {...props} />;
}

export default memo(PressableOverlay);
